import React from 'react';

const BS_Jumbotron = () => {
    return (
        <div>
            <h1>BS_Jumbotron Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Jumbotron;
